import React, { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Row, Col } from "antd";
import { QuestionCircleFilled  } from '@ant-design/icons'
import { AppContext } from '../util/context';
import logo from "../assets/tucker_logo.png";
import { 
    MenuFoldOutlined, 
    MenuUnfoldOutlined, 
    HomeFilled, 
    FileAddFilled, 
    ReconciliationFilled, 
    WalletFilled, 
    ProjectFilled, 
    PieChartFilled,
    AppstoreFilled   
} from '@ant-design/icons'


const today = new Date();
const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
const longFormDate = today.toLocaleDateString('en-US', options);


export const NavView = ({landing, selection, appProps, setShowAuthenticator}) => {
    const {
        userData,
        StyledDiv,
        isRep,
        SignIn,
        handleSignOut
    } = useContext(AppContext);
    const navigate = useNavigate();
    const [showMenu, setShowMenu] = useState(false);
    return (
        <>
            <Row 
                style={{
                    height: "9dvh",
                    boxShadow: "0 1px 3px 0px rgb(0, 0, 0, 0.1)",
                    padding: "0",
                    backgroundColor:"white",
                    
                }}
                className="navContainer"
            >
                <Col
                    
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'start',
                        paddingLeft: "15px"
                    }}
                    xl={{span: 3}}
                    lg={{span: 3}}
                    md={{span: 12}}
                    sm={{span: 12}}
                    xs={{span: 12}}
                >

                    <img
                        src={logo}
                        alt="Tucker Logo"
                        style={{
                            width: '120px',
                            height: '35px',
                        }}
                    />
                
                </Col>

                <Col
                    style={{
                        display: 'flex',
                        height: "100%"
                    }}
                    xl={{span: 21}}
                    lg={{span: 21}}
                    md={{span: 12}}
                    sm={{span: 12}}
                    xs={{span: 12}}
                >
                    {landing && <div style={{
                        display: "flex",
                        justifyContent: "end",
                        alignItems: "center",
                        height: "100%",
                        width: "100%",
                        paddingRight: "15px",
                    }}>
                        <StyledDiv>
                            <button onClick={() => SignIn()}className="signInButton">Sign In</button>
                        </StyledDiv>
                    </div>}

                    {!landing && userData && <Row style={{
                        width: "100%",
                    }}>
                        <div className="navText">
                            <Row
                                style={{
                                    height: "100%"
                                }}
                            >
                                <Col span={12}
                                    style={{
                                        display: "flex",
                                        /* justifyContent: "start", */
                                        alignItems: "center",
                                        paddingLeft: "20px",
                                    }}
                                >
                                    <StyledDiv>
                                        <p style={{
                                            margin: 0,
                                            fontWeight: "600",
                                            fontSize: "13px",
                                            
                                        }}>Welcome {userData.given_name} {userData.family_name}!</p>
                                    </StyledDiv>

                                    <StyledDiv>
                                        <p style={{
                                            margin: 0,
                                            fontSize: "10px",
                                            fontWeight: "600",
                                            marginLeft: "20px"
                                            
                                        }}>{longFormDate}</p>
                                    </StyledDiv>
                                </Col>

                                <Col span={12}
                                    style={{
                                        display: "flex",
                                        justifyContent: "end",
                                        alignItems: "center",
                                        height: "100%",
                                    }}
                                >
                                    <Row
                                        style={{
                                            paddingRight: "50px",
                                            fontSize: "25px",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            justifyContent: "center"
                                        }}
                                    >
                                        <QuestionCircleFilled
                                            style={{
                                                color: "#FFC000",
                                                cursor: "pointer",
                                                fontSize: "3dvh",
                                                marginBottom: "5px" 
                                            }}
                                            onClick={() => window.open('https://tuckerenergy.sharepoint.com/sites/QHSSE-TT/Tutorials/Behaviour%20Based%20%20Hazards/Forms/AllItems.aspx?id=%2Fsites%2FQHSSE%2DTT%2FTutorials%2FBehaviour%20Based%20%20Hazards%2FObservation%20Card%20Tutorials&viewid=a589181e%2Dcf7f%2D4f63%2Da9d6%2D3940d6749262', '_blank')}
                                        />
                                        <StyledDiv>
                                            <p 
                                                style={{
                                                    margin: 0,
                                                    fontSize: "8px",
                                                    fontWeight: "600",
                                                    textAlign: "center",
                                                    cursor: "pointer",
                                                }}
                                                onClick={() => window.open('https://tuckerenergy.sharepoint.com/sites/QHSSE-TT/Tutorials/Behaviour%20Based%20%20Hazards/Forms/AllItems.aspx?id=%2Fsites%2FQHSSE%2DTT%2FTutorials%2FBehaviour%20Based%20%20Hazards%2FObservation%20Card%20Tutorials&viewid=a589181e%2Dcf7f%2D4f63%2Da9d6%2D3940d6749262', '_blank')}
                                            
                                            >Click here to view guides on the Observation Card System</p>
                                        </StyledDiv>
                                    </Row>
                                    <Row
                                        style={{
                                            width: "300px",
                                            height: "100%",
                                            backgroundColor: "#FFC000",
                                            borderTopLeftRadius: "3px",
                                            borderBottomLeftRadius: "3px",
                                        }}
                                    >
                                        <Col
                                            span={24}
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                height: "100%",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    marginBottom: "5px"
                                                }}
                                            >
                                                <StyledDiv>
                                                    <p style={{
                                                        margin: 0,
                                                        fontSize: "2.2dvh",
                                                        fontWeight: "500",
                                                        color: "white"
                                                    }}>OBSERVATION CARD</p>
                                                </StyledDiv>
                                            </div>
                                        </Col>
                                        
                                    </Row>
                                </Col>
                            
                            </Row>
                            

                            
                        </div>

                        <div
                            className="navMenu"
                        >
                            <Row
                                style={{
                                    height: "100%"
                                }}
                            >
                                <Col span={24}
                                    style={{
                                        display: "flex",
                                        justifyContent: "end",
                                        alignItems: "center"
                                    }}
                                >
                                    {!showMenu && <MenuFoldOutlined 
                                        className="menuIcon"
                                        onClick={() => setShowMenu(true)}
                                    />}

                                    {showMenu && <MenuUnfoldOutlined
                                        className="menuIcon"
                                        onClick={() => setShowMenu(false)}
                                    />}
                                </Col>
                            </Row>
                        </div>
                    </Row>}
                </Col>
            </Row>

            {showMenu && <>
                <Row 
                    style={{
                        marginTop: "9dvh",
                        height: "100dvh",
                        padding: "0",
                        backgroundColor:"rgba(0, 0, 0, 0.8)",
                        backdropFilter: "blur(3px)"
                    }}
                    className="navContainer navMenu"
                    
                >
                    <Col
                        span={24}
                        style={{
                            height: "310px",
                            padding: "0",
                            backgroundColor: "#FFC000",
                            paddingTop: "5px"
                        }}
                    >
                        <Row
                            style={{
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            <Col
                                span={12}
                                style={{
                                    display: "flex",
                                    justifyContent: "start",
                                    paddingLeft: "5px"
                                }}
                            >
                                <StyledDiv>
                                    <p style={{
                                        margin: 0,
                                        color: "white",
                                        fontSize: "13px"
                                    }}>Welcome {userData.given_name} {userData.family_name}!</p>
                                </StyledDiv>
                                
                            </Col>

                            <Col
                                span={12}
                                style={{
                                    display: "flex",
                                    justifyContent: "end",
                                    paddingRight: "5px"
                                }}
                            >
                                <StyledDiv>
                                    <p style={{
                                        margin: 0,
                                        fontSize: "11px",
                                        color: "white"
                                    }}>{longFormDate}</p>
                                </StyledDiv>
                                
                            </Col>
                        </Row>

                        <Row
                            gutter={[0, 46]}
                            style={{
                                display: "flex",
                                marginTop: "20px"
                            }}
                        >
                            <Col
                                span={8}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <div
                                    className="menuContainer"
                                    onClick = { () => navigate('/newhome')}
                                >
                                    <HomeFilled 
                                        className={selection === "home" ? "menuTextIconSelected" : "menuTextIcon"}
                                    />
                                    <StyledDiv
                                        className={selection === "home" ? "selectedMenuText" : "menuText"}
                                        style={{
                                            marginTop: "6px"
                                        }}
                                    >HOME</StyledDiv>
                                </div>
                            </Col>

                            <Col
                                span={8}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <div
                                    className="menuContainer"
                                    onClick = { () => navigate('/newcard')}
                                >
                                    <FileAddFilled 
                                        className={selection === "newcard" ? "menuTextIconSelected" : "menuTextIcon"}
                                    />
                                    <StyledDiv
                                        className={selection === "newcard" ? "selectedMenuText" : "menuText"}
                                        style={{
                                            marginTop: "6px"
                                        }}
                                    >NEW CARD</StyledDiv>
                                </div>
                            </Col>

                            {/* <Col
                                span={8}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                            </Col> */}

                            {isRep &&<Col
                                span={8}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <div
                                    className="menuContainer"
                                    onClick = { () => navigate('/review')}
                                >
                                    <ProjectFilled 
                                        className={selection === "review" ? "menuTextIconSelected" : "menuTextIcon"}
                                    />
                                    <StyledDiv
                                        className={selection === "review" ? "selectedMenuText" : "menuText"}
                                        style={{
                                            marginTop: "6px"
                                        }}
                                    >QHSSE REVIEW</StyledDiv>
                                </div>
                            </Col>}

                            <Col
                                span={8}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <div
                                    className="menuContainer"
                                    onClick = { () => navigate('/actiontracker')}
                                >
                                    <ReconciliationFilled 
                                        className={selection === "actiontracker" ? "menuTextIconSelected" : "menuTextIcon"}
                                    />
                                    <StyledDiv
                                        className={selection === "actiontracker" ? "selectedMenuText" : "menuText"}
                                        style={{
                                            marginTop: "6px"
                                        }}
                                    >ACTION TRACKER</StyledDiv>
                                </div>
                            </Col>

                            <Col
                                span={8}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <div
                                    className="menuContainer"
                                    onClick={() => window.open('https://app.powerbi.com/groups/f12ae0a6-d061-41ef-9482-eed45db3fb4f/reports/41529204-7930-43c9-ad1f-fb8744917cc4/a898f030701bdd1066d0?experience=power-bi', '_blank')}
                                >
                                    <PieChartFilled 
                                        className="menuTextIcon"
                                    />
                                    <StyledDiv
                                        className="menuText"
                                        style={{
                                            marginTop: "6px"
                                        }}
                                    >REPORTS</StyledDiv>
                                </div>
                            </Col>

                            {/* <Col
                                span={8}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <div
                                    className="menuContainer"
                                    onClick = { () => window.open('https://behaviour.tuckerenergyapps.com', '_blank')}
                                >
                                    <AppstoreFilled 
                                        className={"menuTextIcon"}
                                    />
                                    <StyledDiv
                                        className={"menuText"}
                                        style={{
                                            marginTop: "6px"
                                        }}
                                    >BEHAVIOUR BASED</StyledDiv>
                                </div>
                            </Col> */}

                            

                            <Col
                                span={8}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <div
                                    className="menuContainer"
                                    onClick = { () => handleSignOut()}
                                >
                                <WalletFilled
                                        className="menuTextIcon"
                                    />
                                    <StyledDiv
                                        className="menuText"
                                        style={{
                                            marginTop: "6px",
                                        }}
                                    >LOGOUT</StyledDiv>
                                </div>
                            </Col>


                            <Col
                                span={8}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <div
                                    className="menuContainer"
                                    onClick={() => window.open('https://tuckerenergy.sharepoint.com/sites/QHSSE-TT/Tutorials/Behaviour%20Based%20%20Hazards/Forms/AllItems.aspx?id=%2Fsites%2FQHSSE%2DTT%2FTutorials%2FBehaviour%20Based%20%20Hazards%2FObservation%20Card%20Tutorials&viewid=a589181e%2Dcf7f%2D4f63%2Da9d6%2D3940d6749262', '_blank')}
                                >
                                <QuestionCircleFilled
                                        className="menuTextIcon"
                                    />
                                    <StyledDiv
                                        className="menuText"
                                        style={{
                                            marginTop: "6px",
                                        }}
                                    >HELP</StyledDiv>
                                </div>
                            </Col>
                            
                        </Row>
                    
                    </Col>

                </Row>
            </>}

            
        </>
    )
}
